<template>
  <div class="forget-page-container">
    <el-container class="forget-page">
      <el-header height="68px">
        <p class="logo-text">找回密码{{test}}</p>
        <a class="back-login" @click="goLogin">返回登录页</a>
      </el-header>
      <div class="step">
        <el-steps :active="active" finish-status="success" align-center>
          <el-step title="身份验证"></el-step>
          <el-step title="设置新密码" v-bind:phoneNumber="phoneNumber" v-bind:message="message"></el-step>
          <el-step title="完成"></el-step>
        </el-steps>
        <div class="change-component">
          <component :is="nextStep" @next="toNext" v-on:sendValueToParent="getValueFromChild" v-bind:phoneNumber="phoneNumber"
            v-bind:message="message"></component>
        </div>
      </div>
    </el-container>

  </div>
</template>

<script>
import Authentication from './forgetPassword/authentication'
import NewPassword from './forgetPassword/newPassword'
import Finish from './forgetPassword/finish'
import CookieOperation from '@/plugins/cookie'
export default {
  name: 'forgetPassword',
  data () {
    return {
      test: '',
      active: 0,
      nextStep: 'authentication',
      phoneNumber: '',
      message: ''
    }
  },
  mounted () {
    this.nextStep = 'authentication'
    this.active = 0
    //  设置网页logo
    let link = document.querySelector("link[rel*='icon']")
    let tenantId = CookieOperation.get('tenantId')
    if (link) {
      link.type = 'image/x-icon'
      link.rel = 'shortcut icon'
      if (tenantId === '1696BDBF-CC00-09CF-B406-9198CC9854E2') {
        link.href = '../../static/favicon1.ico'
      } else {
        link.href = '../../static/favicon.ico'
      }
    }
  },
  components: {
    Authentication,
    NewPassword,
    Finish
  },
  methods: {
    getValueFromChild (phoneNumber, message) {
      this.phoneNumber = phoneNumber
      this.message = message
    },
    toNext (data) {
      this.active = data
      switch (this.active) {
        case 0:
        {
          this.nextStep = 'authentication'
          break
        }
        case 1:
        {
          this.nextStep = 'NewPassword'
          break
        }
        case 2:
        {
          this.nextStep = 'Finish'
          break
        }
      }
    },
    goLogin (userType) {
      this.$router.push({name: 'login'})
    }
  },
  created () {
    let params = { 'domain': document.domain }
    let tenantInfo = localStorage.getItem('tenantInfo')
    if (tenantInfo) {
      document.title = JSON.parse(tenantInfo).applicationName
    } else {
      this.$axios.get('/system-api/application/getSettingByDomain', {params, timeout: 4000}).then(res => {
        if (res.data.data) {
          document.title = res.data.data.applicationName
          localStorage.setItem('tenantInfo', JSON.stringify(res.data.data))
        } else {
          document.title = '红猫系统设计平台'
        }
      }).catch(() => { document.title = '红猫系统设计平台' })
    }
  }
}

</script>
<style lang="scss">
  .forget-page-container {
    background-color: #fff;
    height: 100%;
    .forget-page {
      height: 100%;
      .step {
        width: 1200px;
        margin: 0 auto;
        margin-top: 170px;

        .el-steps {
          padding-bottom: 70px;

          .el-step__line {
            top: 15px;
          }

          .is-text {
            height: 30px;
            width: 30px;
          }
          .is-success{
            .el-step__line{
              background-color: var(--primary, #2F96E7);
            }
          }
          .is-process,.is-success  {
            border-color: var(--primary, #2F96E7);
            color: var(--primary, #2F96E7);

            .is-text{
              color: var(--primary, #2F96E7);
              border: 2px solid var(--primary, #2F96E7);
            }
          }

          .el-step__title {
            font-weight: normal;
            font-size: 16px;
          }

          .is-process {
            color: var(--primary, #2F96E7);
          }
        }

        .el-button {
          display: block;
          width: 140px;
          height: 32px;
          margin: 0 auto;
        }

        .change-component {
          display: flex;
          justify-content: center;
          width: 450px;
          margin: 0 auto;
          padding-bottom: 40px;
        }
      }

      .el-header {
        border-bottom: 1px solid rgba(240, 240, 240, 1);

        .logo {
          margin-top: 19px;
          margin-left: 120px;
          margin-right: 13px;
          width: 79px;
          height: 31px;
          padding-right: 13px;
          border-right: 1px solid #f0f0f0;
        }

        .logo-text {
          display: inline-block;
          width: 90px;
          height: 68px;
          line-height: 68px;
          font-size: 18px;
          font-weight: 400;
          color: rgba(34, 38, 46, 1);
          vertical-align: baseline;
        }

        .back-login {
          text-decoration: none;
          position: absolute;
          color: #808080;
          cursor: pointer;
          top: 27px;
          right: 120px;

          &:hover {
            color: #494949
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/system/forget-password.vue